import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CartState } from '@plys/src/application/states/cart.state';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { isCartExpiredError } from './api-error';

/**
 * The one place a dead cart is recognised, wherever in the flow the request came from: reserving a
 * line, editing one, validating the cart, creating the order. Flagging it on {@link CartState} is what
 * makes the checkout wrapper open its unclosable notice and restart the flow with the `cart_id`
 * dropped — so no step has to answer an expired cart on its own, and none of them answer it
 * differently.
 *
 * Matched on the error type alone rather than on a status as well: `cart_expired` says the same thing
 * whichever status the endpoint that refused chose to send it with.
 */
@Injectable()
export class CartExpiredInterceptor implements HttpInterceptor {
  constructor(private cartState: CartState) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (isCartExpiredError(error)) {
          this.cartState.setExpiredError();
        }
        return throwError(() => error);
      })
    );
  }
}
